import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { dataGridModel, queryClient as qc, statuses } from 'keys';
import { AbilityAssessmentsTable, assessmentsHooks, TableToolbar } from '.';
import { initialPage } from 'keys/pagination';
import { Table } from 'components';
import { AssessmentsContext, batteryStatusOptions } from './AssessmentsContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAssessmentReportsByBatteryFetch } from 'store/middlewares/assessment.crud';
import { ReportDrawer } from '../Report';

const AssessmentTable = (props) => {
    const { setSelectedAssessments, selectedAssessments, type, uniqueId, blurred, queryKey, rowWithBg, withTabs, onRowSelection, modelKey, page, setPage, loading, data: items, nestedTable, columns, nestedColumns } = props;
    const { isBatteryTab, assessmentFilters, batteryDefs, setAssessmentFilters, resetRowSelection, pageSize, setPageSize, assessmentOptions, sorting, setSorting, searchVal, setSearchVal, assessments, collapseSearchVal, rowOpen, setRowOpen, openRowIndex, setOpenRowIndex, setCollapseSearchVal, viewReportId, setViewReportId } = useContext(AssessmentsContext)
    const { headerFilters } = useSelector(state => state.header)

    const [data, setData] = useState(null)
    const queryClient = useQueryClient()

    let filterSchemaBattery = {
        primary: [
            { key: 'profile' },
        ],
        advanced: [
            { key: "school_year" },
            { key: "semester" },
            { key: "grade_of_execution", },
            { key: 'battery_status', overrides: { minWidth: 150, width: 150, component: "autoComplete", name: 'battery_status', placeholder: 'סטטוס דוח', options: batteryStatusOptions }, },
            { key: "battery", overrides: { name: "battery", width: 320, placeholder: "שם הסוללה", disabled: false, component: "autoComplete", options: batteryDefs, labelKey: "label" } },
        ]
    }

    let filterSchemaSingle = {
        primary: [
            { key: 'profile' },
        ],
        advanced: [
            { key: "school_year" },
            { key: "semester" },
            { key: "grade_of_execution", },
            { key: "activated_by" },
            { key: 'status' },
            { key: 'categories' },
            { key: 'assessment_defs' }
        ]
    }

    const assessment = useQuery({
        queryKey: [qc.bateryAssessments, rowOpen],
        queryFn: async () => {
            const rowItem = items.data.results?.find(({ id }) => id == rowOpen)
            if (rowItem) {
                const { data } = await getAssessmentReportsByBatteryFetch(rowItem.id)
                setData(data)
                return data
            }
            return null
        },
        enabled: items.data?.results && rowOpen != null,
    })

    useEffect(() => {
        setPage(initialPage)
        setRowOpen(null)
    }, [headerFilters])

    useEffect(() => {
        //אם אותה שורה נפתחת פעם שנייה הקריאת שרת לא תתבצע שוב ואנחנו מעוניינים לשלוף מהמטמון
        const bateryAssessmentsPrevRow = queryClient.getQueryData([qc.bateryAssessments, rowOpen])
        if (bateryAssessmentsPrevRow)
            setData(bateryAssessmentsPrevRow)
    }, [rowOpen])

    const onCollapse = useCallback((id, rowIndex) => {
        setRowOpen(rowIndex)
        setData(null)
    }, [])

    const handleClose = useCallback(() => {
        setViewReportId(null)
    }, [])

    return (
        <>
            <Table
                key={type}
                filterSchema={isBatteryTab ? filterSchemaBattery : filterSchemaSingle}
                filterValues={assessmentFilters}
                onFilterChange={setAssessmentFilters}
                flexGrow
                visibilityModelKey={modelKey}
                withTitle
                uniqueId={uniqueId}
                rowOpen={rowOpen}
                setRowOpen={setRowOpen}
                rowWithBg={rowWithBg ? (row) => row.original.battery_label : null}
                rowClassName={(row) => row.original.status === statuses.notForExecution && 'not-for-execution-row'}
                blurred={blurred}
                collapse={{
                    show: nestedTable,
                    columns: nestedColumns,
                    showToolbar: true,
                    component: () =>
                        <AbilityAssessmentsTable
                            data={data}
                            nestedColumns={nestedColumns}
                            nestedTable={nestedTable}
                        />,
                    data: data,
                    blurred: ({ original }) => original.assessment_hidden,
                    onCollapse: onCollapse,
                    showChollapseIcon: true,
                    visibilityModelKey: dataGridModel.assessment_battery,
                }}
                selectedRowIds={selectedAssessments ?? {}}
                setSelectedRowIds={setSelectedAssessments}
                onRowSelection={onRowSelection}
                resetRowSelection={resetRowSelection}
                loading={loading}
                data={items.data || { results: [] }}
                columns={columns}
                page={page}
                setPage={setPage}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                pageSize={pageSize}
                setPageSize={setPageSize}
                queryKey={queryKey}
            // customToolbar={<TableToolbar />}
            />
            <ReportDrawer
                open={viewReportId}
                handleClose={handleClose}
                assessmentID={viewReportId}
            />
        </>
    );
}

export default AssessmentTable
